import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import ComingSoon from '@app/components/presentational/ComingSoon';
import HomePage from './HomePage';
import PostDetailMobileScreen from './widgets/RecentUpdates/PostDetailMobileScreen';
import UpcomingAssignmentsMobileScreen from './widgets/upcomingAssignmentsWidget/UpcomingAssignmentsMobileScreen';
import { useMediaQuery, useTheme } from '@ublend-npm/aulaui-core';
import { useSelector } from 'react-redux';
import { location as getLocation } from '@app/selectors/routing';

const HomeToggle = () => {
  const { webAppFtHomePageEnableFlag202605 } = useFlags();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const pathname = useSelector(getLocation)?.pathname ?? '';
  const match = pathname.match(/\/home\/post\/(.+)/);
  const routePostId = match ? match[1] : null;
  const isUpcomingAssignmentsRoute = pathname === '/home/upcoming-assignments';

  if (webAppFtHomePageEnableFlag202605) {
    if (routePostId && isSmallScreen) {
      return <PostDetailMobileScreen routePostId={routePostId} />;
    }
    if (isUpcomingAssignmentsRoute && isSmallScreen) {
      return <UpcomingAssignmentsMobileScreen />;
    }
    return <HomePage />;
  }

  return <ComingSoon />;
};

export default HomeToggle;
